import { callApi } from '@helpers/api';
import { keysToCamel } from '@helpers/camelCaseConverter';

const getVLearnAppApi = agent => () => agent.get('auth/accessVlearn/');

export const getVLearnApp = () =>
  callApi(getVLearnAppApi)()
    .then(response => {
      response = keysToCamel(response);
      return response;
    })
    .catch(error => error);
